import { GET_WEEKLY_KPI, UPDATE_MONTHLY_KPI } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_WEEKLY_KPI:
            return action.payload;
        case UPDATE_MONTHLY_KPI:
            return state.map((kip) => {
                if (kip.id === action.payload.id) {
                    return action.payload;
                }
                return kip;
            });
        default:
            return state;
    }
}